var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"CommonBgColorRef",staticClass:"CommonBgColor-box"},[_c('div',{staticClass:"CommonBgColor-Chunk"},[_c('CommonBgColorChunk')],1),_c('div',{staticClass:"CommonBgColor-More"},[_c('CommonMoreBgColor')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }